<div class="sec-title">
    <h1>Modifier le bon de commande #{{orderInfo.order_no}}</h1>
  </div>
  
  <div>
    <a class="btn btn-action" href="/commandes" routerLink="/commandes" role="button">
      <i class="bi bi-arrow-90deg-left"></i> retour aux bons de commande
    </a>
  </div>
  
  <div style="width:100%;">
    <div class="alert alert-success p-3"  role="alert" *ngIf="update_message!=''">{{update_message}}</div>
    <form [formGroup]="editOrderForm" (ngSubmit)="onSubmit(editOrderForm.value, orderItemsForm.value)" novalidate>
      <fieldset class="col-12 float-lg-left form-group mb-3">
        <legend>Info Client/Contrat</legend>
        <div class="fieldset-wrap">
          <div class="float-lg-start col-sm-12 col-lg-5">
            <fieldset [ngClass]="{'client-lg-fr' : clientInfo.client_language_code == 'FR', 'client-lg-en' : clientInfo.client_language_code == 'EN' }">
              <legend class="sub-label">Client:</legend>
              <div class="infobox fieldset-wrap">
                  <div class="float-lg-start col-sm-12 col-lg-6">
                      <div class="form-group mb-2">
                          <label class="form-label">Client</label>
                          <span>{{clientInfo.client_fname}} {{clientInfo.client_lname}}</span>
                      </div>

                      <div class="form-group mb-2">
                          <label class="form-label">Adresse principale</label>
                          <span>{{clientInfo.client_address}} {{clientInfo.client_address2}}, {{clientInfo.client_city}}, {{clientInfo.client_province}}, {{clientInfo.client_postalcode}} {{clientInfo.client_country}}</span>
                      </div>

                      <div class="form-group mb-2">
                          <label class="form-label">Langue</label>
                          <span>{{clientInfo.client_language_name}}</span>
                      </div>
                  </div>
                  <div class="float-lg-end col-sm-12 col-lg-6">
                    <div class="mb-2" *ngFor="let contactType of contactTypeList; let i = index;">
                      <label class="form-label">{{contactType.client_contact_type_name}}</label>
                      <div >{{contactType.value}}</div>
                    </div>  
                  </div>
              </div>
            </fieldset>
          </div>
          <div class="float-lg-end mt-3 col-sm-12 col-lg-6">
            <div class="form-group mb-3">
              <label for="submission_no" class="form-label">Numéro de contrat</label>
              <span>Contrat  #{{contractInfo.submission_no}}</span>
            </div>
            <div class="form-group mb-3">
                  <label class="form-label">Travaux exécutés au</label>
                  <span>{{contractInfo.address}} {{contractInfo.address2}}, {{contractInfo.city}}, {{contractInfo.province}}, {{contractInfo.postalcode}} {{contractInfo.country}}</span>
            </div> 
            <div class="form-group mb-3">
              <label for="order_note" class="form-label">Note</label> 
              <textarea class="form-control" name="order_note" id="order_note" formControlName="order_note" value="{{orderInfo.note}}" ></textarea>
            </div> 
          </div>
        </div>
      </fieldset>

      <fieldset class="col-12 form-group mb-3">
      <legend>Info Bon de commande</legend>
      <div class="fieldset-wrap">
        <div class="float-lg-end mb-5 col-sm-12 col-lg-12">
            <div class="float-lg-start mt-3 col-sm-12 col-lg-4">
              <div class="form-group mb-3">
                <a (click)="orderPrint(orderInfo.order_id)" role="button"><i class="bi bi-printer-fill btn-add-one"></i><span class="txt-add-one ms-2">Imprimer la commande</span></a>
              </div>
            </div>
            <div class="float-lg-end mt-3 col-sm-12 col-lg-4">
              
              <div class="form-group mb-3">
                <span class="form-label">Numéro de la commande: </span><span class="page_marker_name">#{{orderInfo.order_no}}</span>
              </div>
              <div class="form-group mb-3">
                <label class="form-label-inline">Dernière mise à jour: </label>
                <span>{{order_updated_date | date:'medium'}}</span>
              </div>
            </div>
        </div>
        <div class="float-start col-12">
          <div class="float-start col-2">
            <div class="form-group mb-3">
              <label for="last_name" class="form-label">Description	</label>
            </div>
          </div>
          <div class="float-start col-10">
            <div class="float-start form-group mb-3 ms-3 col-2">
              <label  class="form-label">Montant</label>
            </div>
            <div class="float-start form-group mb-3 ms-3 col-1">
              <label class="form-label">Taxable</label>
            </div>
            <div class="float-start form-group mb-3 ms-3 col-1">
              <label class="form-label">Qty comm.</label>
            </div>
            <div class="float-start form-group mb-3 ms-3 col-1">
              <label class="form-label">Qty reçu</label>
            </div>
            <div class="float-start form-group mb-3 ms-3 col-2">
              <label class="form-label">Total commandé</label>
            </div>
            <div class="float-start form-group mb-3 ms-3 col-2">
              <label class="form-label">Total reçu</label>
            </div>
            <div class="float-start form-group mb-3 ms-3 col-1">
              <label for="gender" class="form-label">Retirer</label>
            </div>
          </div>
        </div>
        <div class="float-start col-12 ">
          <form [formGroup]="orderItemsForm" *ngIf="renderForm()">
          <div class="form-group mb-3"  *ngFor="let orderItem of orderItemsList; let i = index; trackBy: trackByOrderItem" >
            <div class="float-start col-2">
              <div class="form-group mb-3">
                <input type="text" placeholder="itème" class="form-control" [name]="getOrderItemControlName(i, 'orderitem_description')" [id]="getOrderItemControlName(i, 'orderitem_description')" [formControlName]="getOrderItemControlName(i, 'orderitem_description')" (input)="onChangeOrderItemDescription(i, $event.target)" />
              </div>
            </div>
            <div class="float-start col-10">
              <div class="float-start form-group mb-3 ms-3 col-2">
                <span class="float-start col-10"><input href="javascript:void(0);" type="number" class="form-control amount" (change)="onChangeOrderItemAmount(i, $event.target)" [name]="getOrderItemControlName(i, 'orderitem_amount')" [id]="getOrderItemControlName(i, 'orderitem_amount')" [formControlName]="getOrderItemControlName(i, 'orderitem_amount')" /></span>
                <span class="float-start mt-3 ms-1 col-1">$</span>
              </div>
              <div class="float-start form-group mb-3 ms-3 mt-2 col-1">
                <input type="checkbox" href="javascript:void(0);" (change)="onChangeOrderItemTax(i, $event)" class="float-start form-check-input amount active" [name]="getOrderItemControlName(i, 'orderitem_istaxable')" [id]="getOrderItemControlName(i, 'orderitem_istaxable')" [formControlName]="getOrderItemControlName(i, 'orderitem_istaxable')" [checked]="orderItem.is_taxable"  />
                <label for="orderitem_istaxable" class="float-start form-check-label d-inline ms-1">Taxe</label>
              </div>
              <div class="float-start form-group mb-3 ms-3 col-1">
                <input href="javascript:void(0);" type="number" class="form-control amount" (change)="onChangeOrderItemQtyOrder(i, $event.target)" [name]="getOrderItemControlName(i, 'orderitem_order-count')" [id]="getOrderItemControlName(i, 'orderitem_order-count')" [formControlName]="getOrderItemControlName(i, 'orderitem_order-count')" /> 
              </div>
              <div class="float-start form-group mb-3 ms-3 col-1">
                <input  href="javascript:void(0);" type="number" class="form-control amount" (change)="onChangeOrderItemQtyOrderRec(i, $event.target)" [name]="getOrderItemControlName(i, 'orderitem_order-received')" [id]="getOrderItemControlName(i, 'orderitem_order-received')" [formControlName]="getOrderItemControlName(i, 'orderitem_order-received')" /> 
              </div>
              <div class="float-start form-group mb-3 ms-3 col-2">
                <span class="d-flex justify-content-end float-start mt-3 col-10">{{this.orderInfoTotals[getOrderItemControlName(i, 'orderitem_total-count')]  | number : '1.2-2'}}</span>
                <span class="d-flex justify-content-end float-start mt-3 col-1">$</span>
              </div>
              <div class="float-start form-group mb-3 ms-3 col-2">
                <span class="d-flex justify-content-end float-start mt-3 col-10">{{this.orderInfoTotals[getOrderItemControlName(i, 'orderitem_total-received')]  | number : '1.2-2'}}</span>
                <span class="d-flex justify-content-end float-start mt-3 col-1">$</span>
              </div>
              <div class="form-group float-start mb-3 ms-3 col-1" >
                <a href="javascript:void(0);" (click)="removeOrderItem(i)" role="button" class="btn-delete"><i class="bi bi-file-x-fill"></i></a>
              </div>
            </div>
          </div>
         </form>
        </div>
        <div class="float-start col-12 mt-3">
          <div class="col-2 d-flex float-start">
            <div class="form-group mb-3">
            </div>
          </div>
          <div class="col-10 d-flex justify-content-end float-start">
            <div class="float-start form-group mb-3 ms-5 col-3">
            </div>
            <div class="d-flex justify-content-end float-start form-group mb-3 ms-3 col-2">
              <label class="form-label">Sous-Total</label>
            </div>
            <div class="d-flex justify-content-end float-start form-group mb-3 ms-3 col-2">
              <label class="form-label">{{this.orderInfoTotals['orderitems-subtotal-count'] | number : '1.2-2'}} $</label>
            </div>
            <div class="d-flex justify-content-end float-start form-group mb-3 ms-3 col-2">
              <label class="form-label">{{this.orderInfoTotals['orderitems-subtotal-received'] | number : '1.2-2'}} $</label>
            </div>
            <div class="float-start form-group mb-3 ms-3 col-2">
              <label class="form-label"></label>
            </div>
          </div>
        </div>
        <div class="float-start col-12">
          <div class="col-2 d-flex float-start">
            <div class="form-group mb-3">
            </div>
          </div>
          <div class="col-10 d-flex justify-content-end float-start">
            <div class="float-start form-group mb-3 ms-5 col-3">
            </div>
            <div class="d-flex justify-content-end float-start form-group mb-3 ms-3 col-2">
              <label class="form-label">TPS</label>
            </div>
            <div class="d-flex justify-content-end float-start form-group mb-3 ms-3 col-2">
              <label class="form-label">{{this.orderInfoTotals['orderitems-tps-total-count'] | number : '1.2-2'}} $</label>
            </div>
            <div class="d-flex justify-content-end float-start form-group mb-3 ms-3 col-2">
              <label class="form-label">{{this.orderInfoTotals['orderitems-tps-total-received'] | number : '1.2-2'}} $</label>
            </div>
            <div class="float-start form-group mb-3 ms-3 col-2">
              <label class="form-label"></label>
            </div>
          </div>
        </div>
        <div class="float-start col-12">
          <div class="col-2 d-flex float-start">
            <div class="form-group mb-3">
            </div>
          </div>
          <div class="col-10 d-flex justify-content-end float-start">
            <div class="float-start form-group mb-3 ms-5 col-3">
            </div>
            <div class="d-flex justify-content-end float-start form-group mb-3 ms-3 col-2">
              <label class="form-label">TVQ</label>
            </div>
            <div class="d-flex justify-content-end float-start form-group mb-3 ms-3 col-2">
              <label class="form-label">{{this.orderInfoTotals['orderitems-tvq-total-count'] | number : '1.2-2'}} $</label>
            </div>
            <div class="d-flex justify-content-end float-start form-group mb-3 ms-3 col-2">
              <label class="form-label">{{this.orderInfoTotals['orderitems-tvq-total-received'] | number : '1.2-2'}} $</label>
            </div>
            <div class="float-start form-group mb-3 ms-3 col-2">
              <label class="form-label"></label>
            </div>
          </div>
        </div>
        <div class="float-start col-12">
          <div class="col-2 d-flex float-start">
            <div class="form-group mb-3">
            </div>
          </div>
          <div class="col-10 d-flex justify-content-end float-start">
            <div class="float-start form-group mb-3 ms-5 col-3">
            </div>
            <div class="d-flex justify-content-end float-start form-group mb-3 ms-3 col-2">
              <label class="form-label">Total</label>
            </div>
            <div class="d-flex justify-content-end float-start form-group mb-3 ms-3 col-2">
              <label class="form-label">{{this.orderInfoTotals['orderitems-total-count'] | number : '1.2-2'}} $</label>
            </div>
            <div class="d-flex justify-content-end float-start form-group mb-3 ms-3 col-2">
              <label class="form-label">{{this.orderInfoTotals['orderitems-total-received'] | number : '1.2-2'}} $</label>
            </div>
            <div class="float-start form-group mb-3 ms-3 col-2">
              <label class="form-label"></label>
            </div>
          </div>
        </div>
        <div class="float-start col-12">
          <div class="form-group mb-3 ms-3">
            <a href="javascript:void(0);" (click)="addOrderItem()" role="button"><i class="bi bi-plus-circle-fill btn-add-one" ></i><span class="txt-add-one ms-2">Ajouter une description</span></a>
          </div>
        </div>
      </div>
      </fieldset>
      <div class="mb-3 mt-2">
        <span class="sub-label">Date de création :</span> {{orderInfo.created  | date:'medium'}}<br/>
        <span class="sub-label">Dernière mise à jour :</span> {{orderInfo.updated  | date:'medium'}}  - <span class="sub-label">par : </span>{{orderInfo.created_by_fname}} {{orderInfo.created_by_lname}} 
      </div>
      <button type="submit" class="btn btn-primary">Enregistrer</button>
    </form>
  </div>
  <hr/>
  <div id="print-section"></div>